import Reveal, { Overline } from "@/components/Reveal";
import { MANIFESTO } from "@/data/site";

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="relative bg-[#0A0F14] py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <Overline>The Manifesto</Overline>
          <h2 className="mt-4 font-display font-extrabold tracking-tight leading-[1.02] text-3xl sm:text-5xl text-white max-w-2xl">
            Four Chapters of <span className="text-[#FFFFFF]">Why.</span>
          </h2>
        </Reveal>

        <div className="mt-16">
          {MANIFESTO.map((c, i) => (
            <Reveal key={c.number} delay={0.05}>
              <div
                data-testid={`manifesto-chapter-${c.number}`}
                className="group grid md:grid-cols-12 gap-6 md:gap-10 py-12 sm:py-16 border-t border-white/10 items-start"
              >
                <div className="md:col-span-3">
                  <span className="font-display font-extrabold text-6xl sm:text-7xl leading-none text-outline-red group-hover:text-[#FFFFFF] transition-colors duration-500">
                    {c.number}
                  </span>
                </div>
                <div className="md:col-span-4">
                  <h3 className="font-display font-bold text-2xl sm:text-3xl text-white tracking-tight uppercase">
                    {c.title}
                  </h3>
                  <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.22em] text-[#FFFFFF]">
                    {c.subtitle}
                  </p>
                </div>
                <div className="md:col-span-5">
                  <p className="text-slate-400 leading-relaxed text-base">{c.content}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
